
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class CounterOrdersGrid extends Serenity.EntityGrid<CounterOrdersRow, any> {
        protected getColumnsKey() { return CounterOrdersColumns.columnsKey; }
        protected getDialogType() { return CounterOrdersDialog; }
        protected getIdProperty() { return CounterOrdersRow.idProperty; }
        protected getInsertPermission() { return CounterOrdersRow.insertPermission; }
        protected getLocalTextPrefix() { return CounterOrdersRow.localTextPrefix; }
        protected getService() { return CounterOrdersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}